/**
 * Kalmix Ground Truth Hub · GA4 Event Layer
 *
 * Loaded only on the Ground Truth Hub template.
 * Uses gtag() when available and falls back to dataLayer.push().
 */
(function () {
  "use strict";

  if (window.KalmixGroundTruthAnalytics) return;

  const PAGE_KEY = "ground_truth";
  const LEAD_SOURCE_KEY = "kalmix_gt_lead_source";
  const viewedSections = new Set();
  const openedFaqs = new Set();

  function cleanParams(params) {
    const cleaned = {};

    Object.keys(params || {}).forEach(function (key) {
      const value = params[key];

      if (value !== undefined && value !== null && value !== "") {
        cleaned[key] = String(value);
      }
    });

    return cleaned;
  }

  function sendEvent(eventName, params) {
    const payload = cleanParams(
      Object.assign(
        {
          source_page: PAGE_KEY
        },
        params || {}
      )
    );

    if (typeof window.gtag === "function") {
      window.gtag("event", eventName, payload);
      return;
    }

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(
        Object.assign(
          {
            event: eventName
          },
          payload
        )
      );
    }
  }

  function storeLeadSource(sourceCta, sourceLocation) {
    const source = {
      source_page: PAGE_KEY,
      source_cta: sourceCta || "unknown",
      source_location: sourceLocation || "unknown",
      recorded_at: new Date().toISOString()
    };

    try {
      window.sessionStorage.setItem(LEAD_SOURCE_KEY, JSON.stringify(source));
    } catch (error) {
      /* Storage may be unavailable in restricted browser contexts. */
    }

    return source;
  }

  function getLeadSource() {
    try {
      const raw = window.sessionStorage.getItem(LEAD_SOURCE_KEY);

      if (!raw) return null;

      return JSON.parse(raw);
    } catch (error) {
      return null;
    }
  }

  function clearLeadSource() {
    try {
      window.sessionStorage.removeItem(LEAD_SOURCE_KEY);
    } catch (error) {
      /* No action needed if storage is unavailable. */
    }
  }

  function trackDataClick(event) {
    const trigger = event.target.closest("[data-gt-event]");

    if (!trigger) return;

    const eventName = trigger.dataset.gtEvent;

    if (!eventName) return;

    const params = {
      gt_location: trigger.dataset.gtLocation,
      gt_target: trigger.dataset.gtTarget,
      gt_label: trigger.dataset.gtLabel,
      gt_destination_type: trigger.dataset.gtDestinationType,
      gt_record_id: trigger.dataset.gtRecordId,
      gt_test_level: trigger.dataset.gtTestLevel
    };

    if (trigger.dataset.gtContactSource) {
      storeLeadSource(
        trigger.dataset.gtContactSource,
        trigger.dataset.gtLocation
      );
    }

    sendEvent(eventName, params);
  }

  function observeSections() {
    const sections = Array.from(
      document.querySelectorAll("[data-gt-section]")
    );

    if (!sections.length || !("IntersectionObserver" in window)) return;

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          const sectionName = entry.target.dataset.gtSection;

          if (!sectionName || viewedSections.has(sectionName)) return;

          viewedSections.add(sectionName);

          sendEvent("gt_section_view", {
            gt_section: sectionName
          });
        });
      },
      {
        root: null,
        rootMargin: "-20% 0px -55% 0px",
        threshold: 0
      }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  function observeFaqs() {
    const faqItems = Array.from(
      document.querySelectorAll("[data-gt-faq-item]")
    );

    faqItems.forEach(function (item) {
      item.addEventListener("toggle", function () {
        if (!item.open) return;

        const questionId = item.dataset.gtQuestionId;

        if (!questionId || openedFaqs.has(questionId)) return;

        openedFaqs.add(questionId);

        sendEvent("gt_faq_open", {
          gt_question_id: questionId
        });
      });
    });
  }

  function init() {
    document.addEventListener("click", trackDataClick);
    observeSections();
    observeFaqs();
  }

  window.KalmixGroundTruthAnalytics = {
    sendEvent: sendEvent,
    getLeadSource: getLeadSource,
    clearLeadSource: clearLeadSource,
    leadSourceKey: LEAD_SOURCE_KEY
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();